export const stringFormattingToCurrency = (value) => {
  if (isNaN(value)) return value;
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    style: "currency",
    currency: "USD",
  }).format(parseFloat(value));
};
